import React from 'react';
import { useTranslation } from 'react-i18next';
import { programs } from './programs';
import ProgramCard from './ProgramCard';
import './StartNowPage.css';

export default function StartNowPage() {
  const { t } = useTranslation('app');
  return (
    <div className="start-now-page">
      <main>
        <section className="start-now-hero">
          <div className="start-now-hero-inner">
            <span className="start-now-hero-eyebrow">{t('navigation.startNow')}</span>
            <h1>{t('navigation.startNow')}</h1><p>{t('startNow.description')}</p>
          </div>
        </section>
        <section className="start-now-content">
          <div className="start-now-content-inner">
            <header className="start-now-section-heading" />
            <div className="start-now-program-grid">
              {programs.map(program => <ProgramCard key={program.id} program={program} />)}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
